/* eslint-disable jsx-a11y/label-has-associated-control */
import cx from 'classnames';
import MediaQuery from 'react-responsive';

import { updateSelectedCurrency } from 'actions/pnlAnaltyics';
import { ASSET_SYMBOL } from 'constants/constants';
import { CURRENCY_STYLE } from 'constants/currency';
import { device } from 'helpers/screenSizes';
import useAccountAnalyticsCurrency from 'hooks/componentHooks/useAccountAnalyticsCurrency';
import useTheme from 'hooks/useTheme';
import { useAppDispatch } from 'storeHooks';
import {
  DollarToggleIcon,
  INRToggleIcon,
  DollarToggleDeactiveIcon,
  InrToggleDeactiveIcon,
} from 'styles/assets/icons';
import Box from 'UIKit/Box';
import MuiCheckBox from 'UIKit/MuiCheckBox';

import classes from './styles.module.scss';

const InrToggleButton = () => {
  const { isLightTheme } = useTheme();
  const { setActiveCurrency, isCurrencyInr } = useAccountAnalyticsCurrency();
  const appDispatch = useAppDispatch();

  const handleToggle = () => {
    const updatedCurrency = isCurrencyInr ? ASSET_SYMBOL : CURRENCY_STYLE.INDIAN;
    setActiveCurrency(updatedCurrency);
    // also need to put state into redux store as all code gets move to selector. so need to detect change
    appDispatch(updateSelectedCurrency(updatedCurrency));
  };

  return (
    <>
      <MediaQuery query={device.up.sm}>
        <label htmlFor="UsdInrToggleButton" className={classes.wrapper}>
          <Box
            className={cx(classes.defaultCurrency, classes.iconWrapper, {
              [classes.toggled]: isCurrencyInr,
              [classes.whiteBg]: isLightTheme,
            })}
          >
            <INRToggleIcon />
            {CURRENCY_STYLE.INDIAN}
          </Box>
          <Box
            className={cx(classes.toggleCurrency, classes.iconWrapper, {
              [classes.toggled]: !isCurrencyInr,
              [classes.whiteBg]: isLightTheme,
            })}
          >
            <DollarToggleIcon />
            {ASSET_SYMBOL}
          </Box>

          <MuiCheckBox
            id="UsdInrToggleButton"
            data-testid="UsdInrToggleButton"
            onChange={handleToggle}
            className={classes.checkbox}
            checked={isCurrencyInr}
          />
        </label>
      </MediaQuery>
      <MediaQuery query={device.down.sm}>
        <label htmlFor="UsdInrToggleButton" className={classes.wrapperMobile}>
          <Box
            className={cx(classes.defaultCurrencyMobile, classes.iconWrapperMobile, {
              [classes.toggledMobile]: isCurrencyInr,
            })}
          >
            {isCurrencyInr ? <INRToggleIcon /> : <InrToggleDeactiveIcon />}
          </Box>
          <Box
            className={cx(classes.toggleCurrencyMobile, classes.iconWrapperMobile, {
              [classes.toggledMobile]: !isCurrencyInr,
            })}
          >
            {isCurrencyInr ? <DollarToggleDeactiveIcon /> : <DollarToggleIcon />}
          </Box>

          <MuiCheckBox
            id="UsdInrToggleButton"
            data-testid="UsdInrToggleButton"
            onChange={handleToggle}
            className={classes.checkboxMobile}
            checked={isCurrencyInr}
          />
        </label>
      </MediaQuery>
    </>
  );
};

export default InrToggleButton;
